module.exports = __webpack_public_path__ + "static/media/close.1297c7c4.svg";